var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Factsheet__Controls d-flex align-items-bottom"},[_vm._t("default"),_c('div',{staticClass:"d-flex ml-auto"},[_vm._t("right"),_c('b-button',{staticClass:"PrintBtn m-3 ml-auto",attrs:{"disabled":_vm.downloadDisabled,"variant":"cta"},on:{"click":_vm.handlePrint}},[_vm._v(" Opslaan als PDF ")])],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }